import React from "react";
import { Route } from "react-router-dom";
import { SecureRoute } from "@okta/okta-react";

/**
 * Builds a React Router route component.
 */
export const AppRoute = ({ component, path, protectedRoute, render }) => {
  const $AppRoute = protectedRoute ? SecureRoute : Route;
  const key = "route-" + path.replace("/", "-").toLowerCase();

  return (
    <$AppRoute exact path={path} component={component} render={render} key={key} />
  );
};

export default AppRoute;
